module.exports = __webpack_public_path__ + "static/media/edit-icon.ac779364.svg";